import moment from "moment";

const distance = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // Radius of the Earth in kilometers
  const dLat = ((lat2 - lat1) * Math.PI) / 180; // Difference in latitude
  const dLon = ((lon2 - lon1) * Math.PI) / 180; // Difference in longitude
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
    Math.cos((lat2 * Math.PI) / 180) *
    Math.sin(dLon / 2) *
    Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = R * c; // Distance in kilometers
  return Math.ceil(distance); //5.3 to 6 km

}

const subStringDate = (value) => {
  if (_.isEmpty(value)) {
    return "invalid date";
  }
  //   .toLocaleTimeString("en-US");
  return new Date(value).toLocaleTimeString("Fr", {
    day: "numeric",
    month: "numeric",
    year: "numeric",
    // timeZone: "UTC+3",
    hour12: true,
    hour: "numeric",
    minute: "numeric",
  });
  // return value.substr(0, 19).replace(/^(.{10}).{1}(.*)/, "$1 $2");
};
const convertSecondToTime = (value) => moment.utc(value * 1000).format('HH:mm:ss')

// return value.substr(0, 19).replace(/^(.{10}).{1}(.*)/, "$1 $2");


const copyToClipboard = (value,
  successfully = () => null,
  failure = () => null) => {
  const clipboard = navigator.clipboard;
  if (clipboard !== undefined && clipboard !== "undefined") {
    navigator.clipboard.writeText(value).then(successfully, failure);
  } else if (document.execCommand) {
    const el = document.createElement("input");
    el.value = value;
    document.body.append(el);

    el.select();
    el.setSelectionRange(0, value.length);

    if (document.execCommand("copy")) {
      successfully();
    }

    el.remove();
  } else {
    failure();
  }
}

export default { subStringDate, copyToClipboard, convertSecondToTime, distance };
